export default "/images/vendor/flag-icon-css/flags/4x3/mx.svg?bc63d25be57acf721e56aa378395e51b";